import logo from './logo.svg';
import './App.css';

import Bog1 from "./media/1A.png";
import Bog2 from "./media/2A.png";
import Bog3 from "./media/6A.png";

function App() {
  return (
       <> 
    <div className='text'
      style={{
        // display: 'inline',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
     paddingTop: "210px",


      }}>
 
    
<div    style={{
position:"relative",
      //  display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
      //   height: '90vh'
        // height: '90vh',
        // margin:"90px",
      }}>

<img 
className="wheel rotate linear infinite" id="img1"
       style={{
        position:"absolute",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        backgroundColor:"transparent",
        // height: '90vh',
        // margin:"90px",
        width: "330px",
  //  height:"333px",
          fontSize:"12px"
      }} src={Bog1} alt='cog1'/>
    
      <img 
className="wheel2 rotate linear infinite" id="img1"
       style={{
  position:"absolute",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        backgroundColor:"transparent",
        // height: '90vh',
        // margin:"90px",
        width: "330px",
  //  height:"333px",
          fontSize:"12px"
      }} src={Bog2} alt='cog1'/>
             
             <img 
className="wheel3 rotate linear infinite" id="img1"
       style={{
//   position:"absolute",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        backgroundColor:"transparent",
        // height: '90vh',
        // margin:"90px",
        width: "330px",
  //  height:"333px",
          fontSize:"12px"
      }} src={Bog3} alt='cog1'/>
    {/* <img 
className="wheel2 rotate linear infinite" id="img1"
       style={{
//   position:"absolute",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        backgroundColor:"transparent",
        // height: '90vh',
        // margin:"90px",
        width: "330px",
      //   paddingTop:"70px",
  //  height:"333px",
          fontSize:"12px"
      }} src={Bog2} alt='cog1'/> */}
  </div>
      </div>
  

  
</>
    
  );
}

export default App;
